<app-job-notification-card
  (closeEvent)="onCloseClickedHandler()"
  [jobNotification]="docoonInboundFlowNotificationCard"
  [notificationIcon]="'svg_purchase_invoice'"
  [pendingMessage]="'Vérification des nouvelles réceptions'"
  [succeedMessage]="
    docoonInboundFlowNotificationCard.newDocumentExistenceFlag ? 'Nouvelles factures disponibles' : 'Aucune nouvelle facture disponible'
  "
>
  <!-- Shown only when the check brought at least one document; the button of the absent kind stays greyed out. -->
  @if (docoonInboundFlowNotificationCard.newDocumentExistenceFlag) {
    <div class="preview-buttons" notification-action-button>
      <button
        (click)="previewPurchaseInvoicesButtonClickedHandler()"
        [attr.aria-label]="'Aperçu des factures d\'achat'"
        [disabled]="docoonInboundFlowNotificationCard.purchaseInvoiceUuids.length === 0"
        data-testid="preview-purchase-invoices-button"
        mat-icon-button
        matTooltip="Aperçu des factures d'achat"
      >
        <mat-icon svgIcon="svg_multiple_preview"></mat-icon>
      </button>
      <button
        (click)="previewPurchaseCreditsButtonClickedHandler()"
        [attr.aria-label]="'Aperçu des avoirs d\'achat'"
        [disabled]="docoonInboundFlowNotificationCard.purchaseCreditUuids.length === 0"
        data-testid="preview-purchase-credits-button"
        mat-icon-button
        matTooltip="Aperçu des avoirs d'achat"
      >
        <mat-icon svgIcon="svg_multiple_preview"></mat-icon>
      </button>
    </div>
  }
</app-job-notification-card>
